import React from "react";

import "./note_history.less";
import { useNoteHook } from "@src/hooks/note_hook";
import { Input } from "antd/lib/index";

const { TextArea } = Input;

interface NoteHistoryProps {
  requestId: number;
}

const NoteHistory: React.FC<NoteHistoryProps> = ({ requestId }) => {
  const { completeNote } = useNoteHook({ requestId: requestId });

  return (
    <TextArea
      data-testid="comments-area"
      rows={4}
      placeholder="No comments available"
      readOnly={true}
      value={completeNote}
      style={{ resize: "none" }}
    />
  );
};

export default NoteHistory;
